import { render, staticRenderFns } from "./business-rejectList.vue?vue&type=template&id=b80bad8c&scoped=true&"
import script from "./business-rejectList.vue?vue&type=script&lang=js&"
export * from "./business-rejectList.vue?vue&type=script&lang=js&"
import style0 from "./business-rejectList.vue?vue&type=style&index=0&id=b80bad8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80bad8c",
  null
  
)

export default component.exports